<template>
    <div :class="{ popup: true, 'popup--visible': visible }">
        <div class="popup__inner" ref="inner">
            <div v-if="title" class="popup__title">
                {{ title }}
            </div>
            <div class="popup__text">
                {{ text }}
            </div>
            <div v-if="buttons" class="popup__buttons">
                <button v-for="button in buttons" type="button" :class="button.cssClass" @click="button.handler(popup)">{{ button.text }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import anime from 'animejs';

export default {
    props: {
        title: {
            type: String
        },
        text: {
            type: String,
            required: true
        },
        buttons: {
            type: Array
        }
    },
    data() {
        return {
            popup: this,
            visible: false
        }
    },
    mounted() {
        this.show();
    },
    methods: {
        show() {
            let width = this.$refs.inner.scrollWidth;
            let height = this.$refs.inner.scrollHeight;

            anime({
                targets: this.$el,
                easing: 'linear',
                duration: 250,
                width: width + 'px',
                height: height + 'px',
                complete: (anim) => {
                    this.visible = true;
                }
            });
        },
        hide() {
            anime({
                targets: this.$el,
                easing: 'linear',
                duration: 200,
                width: '0px',
                height: '0px',
                complete: (anim) => {
                    this.visible = false;
                }
            });
        },
        close() {
            this.$parent.$emit('popup.closed', this);
            this.$el.remove();
            this.$destroy();
        }
    }
}
</script>

<style lang="scss">
.popup {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 0;
    height: 0;
    overflow: hidden;

    &__inner {
        position: absolute;
    }

    &--visible {
        overflow: visible;
    }
    &--visible &__inner {
        position: relative;
    }
}
</style>